"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABVersionHook = void 0;
/**
 * force active to in-house app
 */
class ABVersionHook {
    constructor(props) {
        const { versions } = props;
        this._versions = versions;
    }
    onActive(oneLink) {
        oneLink.params.abVersions = this._versions;
    }
}
exports.ABVersionHook = ABVersionHook;
